export default __webpack_public_path__ + "static/thumb-landscape-a607dce6357554ba1a8ab0c82e34ac18.jpg";